import { mmkv } from '@/storage/mmkv';
import type { DeploymentConfig } from '@/types/deployment';

// Base config from environment variables (triggers dev-mode when both are empty)
const envConfig = {
  userPoolId: process.env.EXPO_PUBLIC_COGNITO_USER_POOL_ID || '',
  clientId: process.env.EXPO_PUBLIC_COGNITO_CLIENT_ID || '',
  region: process.env.EXPO_PUBLIC_AWS_REGION || 'us-east-1',
};

// Try to read the persisted deployment config (written by deploymentStore.setConfig).
// When present, the stack's pool takes precedence so the platform identity token is
// the same one the backend API authorizes against.
function resolveDeploymentOverride(): {
  userPoolId: string;
  clientId: string;
  region: string;
} {
  try {
    const raw = mmkv.getString('deployment_config');
    if (!raw) return envConfig;
    const cfg = JSON.parse(raw) as Partial<DeploymentConfig>;
    return {
      userPoolId: cfg.userPoolId || envConfig.userPoolId,
      clientId: cfg.userPoolClientId || envConfig.clientId,
      region: cfg.region || envConfig.region,
    };
  } catch {
    return envConfig;
  }
}

export const cognitoConfig = resolveDeploymentOverride();
